<template>
  <div class="relative" @click="togglePanel">
    <Icon name="notification" class="mt-2 w-6 h-6 text-gray-600 mr-8"/>
    <span
      class="absolute top-1 left-3 block h-3 w-3 rounded-full ring-2 ring-white bg-red-400"
      v-if="unreadCount && !withNumber">
    </span>
    <span
      class="absolute top-1 left-3 flex items-center justify-center text-xs font-bold h-5 w-5 rounded-full ring-2 ring-white bg-red-400 text-white"
      v-if="unreadCount && withNumber">
      {{ unreadCount }}
    </span>
    <NotificationPanel
      :notifications="notifications"
      :show="showPanel"
      :loading="loading"
      @scroll="handleScroll"
      @markAllAsRead="markAllAsRead"
      @markAsRead="markAsRead"
    />
  </div>
</template>

<script>
import axios from 'axios';
import useSWRV from 'swrv'
import moment from 'moment';

import Icon from "@/Shared/Icon.vue";
import NotificationPanel from "@/Shared/NotificationPanel.vue";
import notifySound from '../assets/audio/notification.wav';
import { useSound } from '@vueuse/sound'

export default {
  components: {
    Icon,
    NotificationPanel
  },
  data() {
    return {
      showPanel: false,
      withNumber: true,
      notifications: this.$page.props.notifications.notifications.data || [],
      totalCount: this.$page.props.notifications.notifications.total,
      unreadCount: this.$page.props.notifications.unread || null,
      loading: false,
      page: 1,
      lastPage: this.$page.props.notifications.notifications.last_page || 1,
    };
  },
  methods: {
    togglePanel() {
      this.showPanel = !this.showPanel;
      if (this.showPanel) {
        this.fetchFreshNotifications();
      }
    },
    handleScroll() {
      if ((this.page + 1) > this.lastPage) {
        return;
      }

      this.page++;
      this.fetchMoreNotifications();
    },
    fetchFreshNotifications() {
      this.loading = true;
      axios.get(this.route('notifications.fetch', {page: 1}))
        .then(response => {
          const _data = response.data
          const newNotifications = _data.notifications.data;
          this.notifications = newNotifications;
          this.unreadCount = _data.unread;
          this.page = _data.notifications.current_page;
          this.lastPage = _data.notifications.last_page;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchMoreNotifications() {
      if (this.loading) return;

      this.loading = true;
      axios.get(this.route('notifications.fetch', {page: this.page}))
        .then(response => {
          const _data = response.data
          const newNotifications = _data.notifications.data;
          this.notifications.push(...newNotifications);
          this.unreadCount = _data.unread;
          this.page = _data.notifications.current_page;
          this.lastPage = _data.notifications.last_page;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    markAllAsRead() {
      this.$inertia.post(this.route('notifications.readall'), {}, {
        preserveScroll: true,
        preserveState: true,
        onSuccess: () => {
          this.notifications.forEach(notification => {
            notification.read_at = moment().toISOString();
          });
          this.unreadCount = 0;
        }
      });
    },
    markAsRead(notification) {
      if (notification.read_at === null) {
        this.$inertia.post(this.route('notifications.read', notification.id), {}, {
          preserveScroll: true,
          preserveState: true,
          onSuccess: () => {
            notification.read_at = moment().toISOString();
            this.unreadCount--;
            window.location.href = this.route('tickets.edit', notification.data.uid);
          },
        });
      }
    },
  },
  created() {
    this.moment = moment;
  },
  mounted() {
    // console.log("component", this.$page);
  },
  setup() {
    const {data: newData} = useSWRV(
      route('notifications.fetch', {page: 1}),
      (url) => fetch(url).then(r => r.json()),
      {
        revalidateOnFocus: true,
        revalidateOnReconnect: true,
        refreshInterval: process.env.SWRV_REFRESH_INTERVAL || 5000,
      }
    )
    const { play } = useSound(notifySound)
    return {
      newData,
      play
    }
  },
  watch: {
    newData: {
      handler: function (val) {
        this.unreadCount = val.unread;
        val.notifications.data.forEach(notification => {
          if (this.notifications.length === 0) {
            this.notifications.push(notification);
          } else {
            const found = this.notifications.find(n => n.id === notification.id);
            if (!found) {
              this.notifications.unshift(notification);
              this.play({
                volume: 0.75,
                interrupt: false,
              });
            }
          }
        });
      },
      deep: true,
    },
  }
}
</script>
